import { render, staticRenderFns } from "./BaseNotifyDropdown.vue?vue&type=template&id=de6d1f4c&"
import script from "./BaseNotifyDropdown.vue?vue&type=script&lang=js&"
export * from "./BaseNotifyDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BaseNotifyDropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports